//
// Compare Users by First Name and then Last Name.
// - This is a case insensitive compare.
//
function byFirstNameThenLastName(thisUser, thatUser) {
  const n = thisUser.firstName.localeCompare(thatUser.firstName, 'en', { sensitivity: 'base' });
  return (n !== 0) ? n : thisUser.lastName.localeCompare(thatUser.lastName, 'en', { sensitivity: 'base' });
}

export default { byFirstNameThenLastName };
